import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Ladder } from 'src/models/ladder.model';

@Injectable({
   providedIn: 'root',
})
export class ProfileService {
  private avatar: { [key: string]: any } = {};

  constructor(private http: HttpClient) { } 
  saveAvatar(newImageBase64: string): Observable<any> {
    return this.http.post<any>(`/api/avatar`,
      {
        base64: newImageBase64
      })
      .pipe(tap((resp: any) => this.avatar[resp.playerid] = { base64img: newImageBase64 }));
  }
  getAvatar(userid: string = null): Observable<any> {
    if (this.avatar[userid]) {
      return of(this.avatar[userid]);
    }
    else {
      return this.http.get<any>(`/api/avatar${userid ? '/' + userid : ''}`)
        .pipe(tap((resp: any) => this.avatar[resp.playerid] = resp))
    }
  }
  public getProfile() {
    return this.http.get<PlayerProfile>(`/api/profile`)
    .pipe(map((m:any) => new PlayerProfile(m)))
  }
  public saveShirtSize(s: string) {
    return this.http.post<any>(`/api/profile/shirtsize/${s}`, null)
  }
   
}

export class PlayerProfile {

  constructor(init?: any) {
    console.log('init is ', init);
    if( init?.userId ) this.userId = init.userId;
    if( init?.shirtSize ) this.userId = init.shirtSize;
  }

  public userId: string;
  public shirtSize?: string = "Large";
}